import "./App.css";

import { BsChatLeftText } from "react-icons/bs";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import React from "react";
import Sidebar from "./components/Sidebar";
import Navbar from "./components/Navbar";
import { useContext } from "react";
import { StateContext } from "./context/ContextProvider";
import Home from "./components/Home/Home";

import Chats from "./components/pages/chats/Chats";
import Teachers from "./components/pages/Teachers/Teachers";

import CalenderCom from "./components/pages/calender/CalenderCom";
import Subjects from "./components/pages/subject/Subject";
import Invoice from "./components/pages/Invoice/Invoice";
import Visa from "./components/pages/PayCard/Visa";

import "./components/style/style.css"
import Setting from "./components/pages/Setting/Setting";



function App() {
  const { activeMenu, setActiveMenu } = useContext(StateContext);

let a;
 for(a= 1; a<=10; a++){
  console.log("hello");
 }
  
  return (
    <div className="  ">
      <BrowserRouter>
        <div className=" flex ">
          <div className=" fixed right-4 bottom-4 " style={{ zIndex: "1000" }}>
            <div
              className="text-white p-4 rounded-full "
              style={{ background: "#610621" }}
            >
              <BsChatLeftText></BsChatLeftText>
            </div>
          </div>

          <div
            className={`  ${
              activeMenu ? "block md:fixed lg:relative z-50" : "hidden"
            } xl:block `}
          >
            <Sidebar></Sidebar>
          </div>
          <div className={`w-full `}>
           <div className={`   duration-300 border ml-7 border-green-600 ${activeMenu?"xl:ml-[255px] ":"xl:ml-20 "}`}>
           <Navbar></Navbar>
           </div>

            <div className={` p-6 sm:p-8 section duration-300 mt-16 ${activeMenu?"xl:ml-[255px] ":"xl:ml-20 "}`}>
              <Routes>
                <Route path="/" element={<Home></Home>} />
                <Route path="/subjects" element={<Subjects></Subjects>} />
                <Route path="/invoice" element={<Invoice></Invoice>} />
                <Route path="/info" element={<Teachers></Teachers>} />

                <Route path="/chat" element={<Chats></Chats>} />
                <Route path="/visa" element={<Visa></Visa>} />
                <Route path="/calender" element={<CalenderCom></CalenderCom>} />
                <Route path="/setting" element={<Setting></Setting>} />
              </Routes>
            </div>
          </div>
        </div>
      </BrowserRouter>
    </div>
  );
}

export default App;
